import { AutogenLayoutOrderIdLookup } from "./autogen/AutogenLayoutOrderIdLookup";
import { Label, TableRowDisplayEvent } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";

export class OrderIdLookup extends AutogenLayoutOrderIdLookup {
    tableMovementsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        const labelStopOriginCityName = tableRow.findComponentById("labelStopOriginCityName");
        if (labelStopOriginCityName) {
            labelStopOriginCityName.tooltip = modelRow.get("stop_origin.city_name");
        }
        const labelStopDestCityName = tableRow.findComponentById("labelStopDestCityName");
        if (labelStopDestCityName) {
            labelStopDestCityName.tooltip = modelRow.get("stop_dest.city_name");
        }

        const labelStopOriginState = tableRow.findComponentById("labelStopOriginState") as Label;
        if (labelStopOriginState) {
            labelStopOriginState.text = ", " + modelRow.get("stop_origin.state");
        }
        const labelStopDestState = tableRow.findComponentById("labelStopDestState") as Label;
        if (labelStopDestState) {
            labelStopDestState.text = ", " + modelRow.get("stop_dest.state");
        }
    }
}
